import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { ThinCheckbox } from 'components/common/Styles';
import FlexBox from 'components/common/FlexBox';
import { IconButton } from '@totalsoft/rocket-ui';

const EngineScoringItem = ({ data, onDelete }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(() => {
    historyContext.push(`/scoringEngine/${data.engineScoringId}`);
  }, [historyContext, data]);

  return (
    <TableRow>
      <TableCell>{data.name}</TableCell>
      <TableCell>{data.code}</TableCell>
      <TableCell align='center'>{data.version}</TableCell>
      <TableCell align='center'>
        <ThinCheckbox disabled={true} checked={Boolean(data.active)} />
      </TableCell>
      <TableCell>{data.validFrom ? t('DATE_FORMAT', { date: { value: data.validFrom, format: 'MM/DD/YYYY' } }) : ''}</TableCell>
      <TableCell>{data.validTo ? t('DATE_FORMAT', { date: { value: data.validTo, format: 'MM/DD/YYYY' } }) : ''}</TableCell>
      <TableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton color='primary' size='small' variant='text' type='edit' tooltip={t('Edit')} onClick={handleEdit} />
          <IconButton
            color='primary'
            size='small'
            variant='text'
            type='delete'
            tooltip={t('Delete')}
            onClick={() => onDelete(data.engineScoringId)}
          />
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

EngineScoringItem.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default EngineScoringItem;
